export const UserModuleIcon = () => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.99725 0L9.99725 16" stroke="white" strokeWidth="0.5" />
      <rect
        width="6.00133"
        height="8"
        transform="translate(6.99609 3.52051)"
        fill="white"
      />
      <path d="M3.00116 0L3.00116 16" stroke="white" strokeWidth="0.5" />
      <rect
        width="6.00133"
        height="5"
        transform="translate(0 2.66699)"
        fill="white"
      />
    </svg>
  );
};

export default UserModuleIcon;
